import { render, staticRenderFns } from "./fourCardFeatureSection.vue?vue&type=template&id=315ca5a6&scoped=true&"
import script from "./fourCardFeatureSection.vue?vue&type=script&lang=js&"
export * from "./fourCardFeatureSection.vue?vue&type=script&lang=js&"
import style0 from "./fourCardFeatureSection.vue?vue&type=style&index=0&id=315ca5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ca5a6",
  null
  
)

/* custom blocks */
import block0 from "../css/card-feature-section/global.css?vue&type=custom&index=0&blockType=syyle&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fviews%2FfourCardFeatureSection.vue&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports